module.exports = __webpack_public_path__ + "img/lingyangzhe.8a1f0cc6.png";